//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatMoney } from "@/utils";
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    theme: {
      type: String,
      default: "light",
    },
    placement: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      showPopover: false,
    };
  },
  methods: {
    formatMoney,
    handleLongtouch(type) {
      this.showPopover = type === "star";
    },
  },
};
